import React from 'react';

import { CustomerContextProvider } from '../../context-providers/CustomerContext';

import { CustomerDetailsPageContent } from './CustomerDetailsPageContent';

const CustomerDetailsPage = () => {
  return (
    <CustomerContextProvider>
      <CustomerDetailsPageContent />
    </CustomerContextProvider>
  );
};

export default CustomerDetailsPage;
